import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { FiltersUiVersion } from '@zaoblako/web/core/types/filters-ui-version.type';
import type { DirectionFindInterface } from '@zaoblako/shared/modules/catalog/dtos/direction/direction-find.dto';
import { DirectionService } from '@zaoblako/web/core/services/finance/direction.service';
import { TreeSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/tree-select/tree-select.component';

@Component({
  standalone: true,
  selector: 'crm-direction-multi-select',
  templateUrl: './direction-multi-select.component.html',
  imports: [CommonModule, TreeSelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DirectionMultiSelectComponent {
  @Input() public loading: boolean;
  @Input() public groupsDisabled = false;
  @Input() public label: string;
  @Input() public styleClass: any;
  @Input() public appendTo = '';
  @Input() public display = 'comma';
  @Input() public scrollHeight = '300px';
  @Input() public showClear = true;
  @Input() public placeholder = 'Выберите статьи';
  @Input() public sort = 'sortIndex:number';
  @Input() public itemStyleClass: string;
  @Input() public filtersUiVersion: FiltersUiVersion = 'v2';
  @Input() public isFloatLabel: boolean | null = null;

  @Output() public selectedDirectionsChange = new EventEmitter<DirectionFindInterface[]>();

  public _directions: DirectionFindInterface[] = [];
  public _selectedDirections: DirectionFindInterface[] = [];
  public filteredDirections: DirectionFindInterface[] = [];

  @Output() public panelShow = new EventEmitter<any>();
  @Output() public panelHide = new EventEmitter<any>();

  @Input()
  public set selectedDirections(directions: DirectionFindInterface[]) {
    this._selectedDirections = directions;
    this.setFilteredDirection();
  }

  @Input()
  public set directions(directions: DirectionFindInterface[]) {
    this._directions = directions;
    this.setFilteredDirection();
  }

  public constructor(private readonly directionService: DirectionService) {}

  private setFilteredDirection() {
    if (this._selectedDirections?.length) {
      const rootDirections: DirectionFindInterface[] = this.directionService
        .getLeafDirectionsWithParent(this._directions)
        .filter(
          (leafDirection) =>
            this._selectedDirections.findIndex((direction) => +direction.id === +leafDirection.id) !== -1
        );
      rootDirections?.forEach((rootDirection) => {
        if (this.filteredDirections.findIndex((direction) => direction.id === rootDirection.id) === -1) {
          this.filteredDirections.push(rootDirection);
        }
        if (rootDirection.children?.length) {
          this.filteredDirections = this.filteredDirections.concat(
            this.directionService.getLeafDirections(rootDirection.children)
          );
        }
      });
    }
  }

  public selectDirectionsHandler(directions: DirectionFindInterface[]) {
    this.selectedDirectionsChange.emit(directions);
  }
}
